/**
 * Human labels for structures, as used when choosing where to move an
 * aggregation node. Mirrors how the map popup titles each structure type.
 *
 * Kept free of imports and of TypeScript-only runtime features so it can be
 * unit-tested directly with `node --experimental-strip-types`.
 */
const TYPE_LABELS = {
    POLE: 'Pole',
    JB: 'Joint box',
    MH: 'Manhole',
    CAB: 'Cabinet',
    CTB: 'CTB',
};
export function structureLabel(structure) {
    const objectClass = String(structure.object_class || '').toUpperCase();
    if (objectClass === 'POLE' && structure.dp_identifier) {
        const sub = structure.sub_pole && structure.sub_pole !== '00' ? ` - ${structure.sub_pole}` : '';
        return `DP${structure.dp_identifier}${sub}`;
    }
    if ((objectClass === 'JB' || objectClass === 'MH') && structure.plant_item) {
        return structure.structure_number
            ? `${structure.plant_item} (${structure.structure_number})`
            : structure.plant_item;
    }
    if (objectClass === 'CAB' && structure.structure_name) {
        return structure.structure_name;
    }
    if (objectClass === 'CTB') {
        return `CTB #${structure.id}`;
    }
    if (structure.plant_item)
        return structure.plant_item;
    if (structure.objectid)
        return `[${structure.objectid}]`;
    return `#${structure.id}`;
}
export function structureTypeLabel(objectClass) {
    const key = String(objectClass || '').toUpperCase();
    return TYPE_LABELS[key] || key;
}
export function formatDistance(metres) {
    if (metres === null || metres === undefined || !Number.isFinite(metres))
        return '';
    if (metres < 999.5)
        return `${Math.round(metres)} m`;
    return `${(metres / 1000).toFixed(1)} km`;
}
